export function parseSSE(sseString: string) {
	const events: Record<string, string>[] = []
	const blocks = sseString.trim().split("\n\n")

	blocks.forEach((block) => {
		const event: Record<string, string> = {}
		const lines = block.split("\n")

		lines.forEach((line) => {
			const [key, ...valueParts] = line.split(":")
			const value = valueParts.join(":").trim()

			if (key === "data") {
				event[key] = event[key] ? event[key] + "\n" + value : value
			} else if (key) {
				event[key] = value
			}
		})

		events.push(event)
	})

	return events
}
